import { useDispatch, useSelector } from "react-redux";
import { State } from "../reducer";
import { getCafeStatus } from "../api/cafe.api";
import { User } from "../interfaces/user";
import { useEffect } from "react";
import { useNavigate } from "react-router";
import React from "react";
import { LayoutAdminCafe, LayoutUserCafe } from "../layout/layout_cafe";
import LandingBar from "./users/menu_bar/components/LandingBar";

const OrderAtBar = () => {
  const user = useSelector((state: State) => state.user);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const storeRedux = (response: User) => {
    dispatch({
      type: "LOGIN",
      payload: response,
    });
  };

  useEffect(() => {
    getCafeStatus().then((result) => {
      const responsepost: User = {
        login: true,
        sub: "auth_google",
        id: user?.id,
        email: user?.email,
        name: user?.name,
        role: user?.role,
        isBarOpen: result?.isBarOpen,
        isCafeOpen: result?.isCafeOpen,
      };
      storeRedux(responsepost);
      result?.isCafeOpen &&
        navigate(
          user?.role === "admin" ? "/statusOrder-admin" : "/statusOrder"
        );
    });
    // Mount-only status check (re-running on user change would loop via storeRedux).
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {" "}
      {user.role === "admin" ? (
        <LayoutAdminCafe>
          <LandingBar />
        </LayoutAdminCafe>
      ) : (
        <LayoutUserCafe>
          <LandingBar />
        </LayoutUserCafe>
      )}
    </>
  );
};

export default OrderAtBar;
